/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'discover',
    path: '/discover',
    meta: { tabbar: 'secret/discover', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'discover_index' },
    children: [
      {
        name: 'discover_index',
        path: '',
        meta: { title: '发现' },
        component: () => import('@/views/discover'),
      },
      {
        name: 'discover_topics',
        path: 'topic',
        meta: { title: '活动与话题' },
        component: () => import('@/views/discover/topics.vue'),
      },
      {
        name: 'discover_online',
        path: 'online',
        meta: { title: '在线用户' },
        component: () => import('@/views/discover/online.vue'),
      },
      {
        name: 'discover_webrtc',
        path: 'webrtc',
        meta: { title: '在线连麦' },
        component: () => import('@/views/discover/webrtc'),
      },
    ],
  },
] as RouteConfig[];
